module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-top": "90px"
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "item flex"
  }, [_c('el-input', {
    staticClass: "com-input",
    attrs: {
      "placeholder": "请输入公司名称",
      "icon": "search",
      "on-icon-click": _vm.search
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "primary-btn absolute",
    on: {
      "click": _vm.search
    }
  }, [_vm._v("检索以完成创建")])], 1), _vm._v(" "), (_vm.isSearched) ? _c('div', [_c('div', {
    staticClass: "info flex flex-between item"
  }, [_c('p', [_vm._v("共" + _vm._s(_vm.total) + "个结果")]), _vm._v(" "), _c('div', {
    staticClass: "goreg",
    on: {
      "click": _vm.gocreate
    }
  }, [_vm._v("没有找到？点击创建新企业")])]), _vm._v(" "), (_vm.rows.length) ? _c('ul', {
    staticClass: "rlist"
  }, _vm._l((_vm.rows), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "item flex flex-between company-item"
    }, [_c('div', {
      staticClass: "company-detail flex"
    }, [_c('div', {
      staticClass: "logo"
    }, [_c('img', {
      attrs: {
        "src": item.logo
      }
    })]), _vm._v(" "), _c('div', {}, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), (item.status == 0) ? _c('button', {
      staticClass: "company-btn",
      on: {
        "click": function($event) {
          _vm.join(item)
        }
      }
    }, [_vm._v("加入")]) : _vm._e(), _vm._v(" "), (item.status == 1) ? _c('button', {
      staticClass: "company-btn"
    }, [_vm._v("已加入")]) : _vm._e(), _vm._v(" "), (item.status == 2) ? _c('button', {
      staticClass: "company-btn"
    }, [_vm._v("审核中")]) : _vm._e(), _vm._v(" "), (item.status == 3) ? _c('button', {
      staticClass: "company-btn"
    }, [_vm._v("禁用中")]) : _vm._e()])
  })) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item m-b-20"
  }, [_c('div', {
    staticClass: "tips"
  }, [_vm._v("请输入您想要创建或加入的公司名称")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1153e60b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/register/join.vue
// module id = 858
// module chunks = 1